<div class="overlay-container">
  <div class="overlay" (click)="onOverlayClick()"></div>
  <app-credit-tier-bar-multiselect-container></app-credit-tier-bar-multiselect-container>
</div>
